<template>
<div class="card card-custom card-strech">
    <div class="card-header border py-5">
        <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark">Registrar planilla</span>
        </h3>
    </div>
    <div class="card-body">
        <div class="page-topbar">
            <div class="title">
                <ul class="nav nav-light-danger nav-bold nav-pills">
                    <li class="nav-item">
                        <div class="nav-link btn" @click="setActive('tab1'), dialogTitle='deportista'" :class="{ active: isActive('tab1') }">
                            <span class="nav-icon">
                                <span class="svg-icon svg-icon-primary svg-icon-2x">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <polygon points="0 0 24 0 24 24 0 24" />
                                            <rect fill="#000000" opacity="0.3" x="2" y="3" width="7" height="14" rx="1" />
                                            <path d="M16.6236387,13.0538007 C18.8273383,13.8579339 20.1826034,13.7956508 21,14 C21.5844894,14.1461224 22.1049236,14.4525789 22.5613025,14.9193695 C22.8220479,15.1860635 23.0030223,15.5203564 23.0837834,15.8844876 C23.3229559,16.9628548 22.6426541,18.0309317 21.5642858,18.2700997 C20.2740329,18.5562665 18.7433451,18.7531138 16.9722222,18.8606416 C13.9910551,19.0416332 8.86226533,19.0463278 1.5858528,18.8747253 C1.26005876,18.867042 0.999953435,18.6007302 0.999953435,18.2748455 L1,18.2748455 C1,15.4124758 1,13.3451074 1,12.0727406 C5.24980707,11.6622656 8.09783699,10.5071287 9.54408978,8.60732991 C9.56481367,8.58010699 9.58782802,8.55470651 9.6128812,8.53140618 C9.85553488,8.30572983 10.2351914,8.31949268 10.4608598,8.56215378 C10.8762386,9.00878105 11.2674202,9.41538104 11.6344046,9.78195376 C11.6101853,9.81416566 11.5876475,9.84819014 11.5669873,9.8839746 L10.0669873,12.4820508 C9.79084492,12.9603434 9.95472008,13.5719338 10.4330127,13.8480762 C10.9113053,14.1242186 11.5228957,13.9603434 11.7990381,13.4820508 L13.1335582,11.1705941 C13.630492,11.5858319 14.0581948,11.8865474 14.4166667,12.0727406 C14.5381042,12.1358162 14.6576898,12.1965218 14.7754507,12.2549561 L14.0669873,13.4820508 C13.7908449,13.9603434 13.9547201,14.5719338 14.4330127,14.8480762 C14.9113053,15.1242186 15.5228957,14.9603434 15.7990381,14.4820508 L16.6236387,13.0538007 Z" fill="#000000" />
                                        </g>
                                    </svg>
                                </span>
                            </span>
                            <span class="nav-text">Deportistas</span>
                        </div>
                    </li>
                    <li class="nav-item">
                        <div class="nav-link btn" @click="setActive('tab2'), dialogTitle='oficial'" :class="{ active: isActive('tab2') }">
                            <span class="nav-icon">
                                <span class="svg-icon svg-icon-primary svg-icon-2x">
                                    <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                                        <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                            <rect x="0" y="0" width="24" height="24" />
                                            <path d="M8,3 L8,3.5 C8,4.32842712 8.67157288,5 9.5,5 L14.5,5 C15.3284271,5 16,4.32842712 16,3.5 L16,3 L18,3 C19.1045695,3 20,3.8954305 20,5 L20,21 C20,22.1045695 19.1045695,23 18,23 L6,23 C4.8954305,23 4,22.1045695 4,21 L4,5 C4,3.8954305 4.8954305,3 6,3 L8,3 Z" fill="#000000" opacity="0.3" />
                                            <path d="M11,2 C11,1.44771525 11.4477153,1 12,1 C12.5522847,1 13,1.44771525 13,2 L14.5,2 C14.7761424,2 15,2.22385763 15,2.5 L15,3.5 C15,3.77614237 14.7761424,4 14.5,4 L9.5,4 C9.22385763,4 9,3.77614237 9,3.5 L9,2.5 C9,2.22385763 9.22385763,2 9.5,2 L11,2 Z" fill="#000000" />
                                            <rect fill="#000000" opacity="0.3" x="7" y="10" width="5" height="2" rx="1" />
                                            <rect fill="#000000" opacity="0.3" x="7" y="14" width="9" height="2" rx="1" />
                                        </g>
                                    </svg>
                                </span>
                            </span>
                            <span class="nav-text">Oficiales Deportivos</span>
                        </div>
                    </li>
                </ul>
            </div>
            <div class="d-flex align-items-center flex-wrap">
                <el-select v-if="activeItem=='tab2'" v-model="record_type" class="mr-2" @change="loadPayroll" placeholder="Tipo de oficial" size="medium">
                    <el-option v-for="item in oficialType" :key="item.id" :label="item.name" :value="item.id"></el-option>
                </el-select>

                <div class="btn btn-s btn-danger mr-2" @click.prevent="openDialogSearch">
                    <span class="svg-icon svg-icon-primary svg-icon-2x">
                        <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="24px" height="24px" viewBox="0 0 24 24" version="1.1">
                            <g stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                                <polygon points="0 0 24 0 24 24 0 24" />
                                <path d="M18,8 L16,8 C15.4477153,8 15,7.55228475 15,7 C15,6.44771525 15.4477153,6 16,6 L18,6 L18,4 C18,3.44771525 18.4477153,3 19,3 C19.5522847,3 20,3.44771525 20,4 L20,6 L22,6 C22.5522847,6 23,6.44771525 23,7 C23,7.55228475 22.5522847,8 22,8 L20,8 L20,10 C20,10.5522847 19.5522847,11 19,11 C18.4477153,11 18,10.5522847 18,10 L18,8 Z M9,11 C6.790861,11 5,9.209139 5,7 C5,4.790861 6.790861,3 9,3 C11.209139,3 13,4.790861 13,7 C13,9.209139 11.209139,11 9,11 Z" fill="#000000" fill-rule="nonzero" opacity="0.3" />
                                <path d="M0.00065168429,20.1992055 C0.388258525,15.4265159 4.26191235,13 8.98334134,13 C13.7712164,13 17.7048837,15.2931929 17.9979143,20.2 C18.0095879,20.3954741 17.9979143,21 17.2466999,21 C13.541124,21 8.03472472,21 0.727502227,21 C0.476712155,21 -0.0204617505,20.45918 0.00065168429,20.1992055 Z" fill="#000000" fill-rule="nonzero" />
                            </g>
                        </svg>
                    </span>
                    Nuevo
                </div>
                <div class="btn btn-light mr-2 d-none">
                    <span class="svg-icon font-weight-bold text-dark-75 mx-0">
                        <svg data-v-3022895a="" data-v-7c235ad9="" aria-hidden="true" focusable="false" data-prefix="fal" data-icon="download" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" class="svg-inline--fa fa-download fa-w-16">
                            <path data-v-3022895a="" data-v-7c235ad9="" fill="currentColor" d="M452 432c0 11-9 20-20 20s-20-9-20-20 9-20 20-20 20 9 20 20zm-84-20c-11 0-20 9-20 20s9 20 20 20 20-9 20-20-9-20-20-20zm144-48v104c0 24.3-19.7 44-44 44H44c-24.3 0-44-19.7-44-44V364c0-24.3 19.7-44 44-44h99.4L87 263.6c-25.2-25.2-7.3-68.3 28.3-68.3H168V40c0-22.1 17.9-40 40-40h96c22.1 0 40 17.9 40 40v155.3h52.7c35.6 0 53.4 43.1 28.3 68.3L368.6 320H468c24.3 0 44 19.7 44 44zm-261.7 17.7c3.1 3.1 8.2 3.1 11.3 0L402.3 241c5-5 1.5-13.7-5.7-13.7H312V40c0-4.4-3.6-8-8-8h-96c-4.4 0-8 3.6-8 8v187.3h-84.7c-7.1 0-10.7 8.6-5.7 13.7l140.7 140.7zM480 364c0-6.6-5.4-12-12-12H336.6l-52.3 52.3c-15.6 15.6-41 15.6-56.6 0L175.4 352H44c-6.6 0-12 5.4-12 12v104c0 6.6 5.4 12 12 12h424c6.6 0 12-5.4 12-12V364z" class=""></path>
                        </svg>
                    </span>
                </div>
                <div class="d-flex align-items-center position-relative mr-2">
                    <span class="svg-icon svg-icon-1 position-absolute ml-3">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                            <rect opacity="0.5" x="17.0365" y="15.1223" width="8.15546" height="2" rx="1" transform="rotate(45 17.0365 15.1223)" fill="black"></rect>
                            <path d="M11 19C6.55556 19 3 15.4444 3 11C3 6.55556 6.55556 3 11 3C15.4444 3 19 6.55556 19 11C19 15.4444 15.4444 19 11 19ZM11 5C7.53333 5 5 7.53333 5 11C5 14.4667 7.53333 17 11 17C14.4667 17 17 14.4667 17 11C17 7.53333 14.4667 5 11 5Z" fill="black"></path>
                        </svg>
                    </span>
                    <input type="text" class="form-control form-control-solid w-200px pl-12" :placeholder="'Buscar en ' + dialogTitle + '...'">
                </div>
            </div>
        </div>

        <div class="tab-content py-3" id="myTabContent">
            <div class="tab-pane fade" :class="{ 'active show': isActive('tab1') }" id="tab1">
                <listAthlete :selection="false" :list="payrollList" @reload="loadPayroll" @onAddEdditDialog="onAddEdditDialog"></listAthlete>
            </div>
            <div class="tab-pane fade" :class="{ 'active show': isActive('tab2') }" id="tab2">
                <listOfficial :selection="false" :list="payrollList"  @reload="loadPayroll" @onAddEdditDialog="onAddEdditDialog"></listOfficial>
            </div>
        </div>
    </div>

    <!--Dialog register player of oficial-->
    <DialogSearch 
        :visible.sync="open_dialog_search" 
        :title="dialogTitle" 
        :record_type="record_type" 
        @resDialogSearch="resDialogSearch" 
        @onAddEdditDialog="onAddEdditDialog">
    </DialogSearch>

    <DialogRegister 
        :visible.sync="open_dialog_register" 
        :title="dialogTitle" 
        :payroll="payroll"
        :record_type="record_type"
        @loadPayroll="loadPayroll">
    </DialogRegister>

</div>
</template>

<script>
//utils
import {
    mapGetters
} from "vuex";
import code from "@/core/config/error";

import {ADD_BODY_CLASSNAME, REMOVE_BODY_CLASSNAME} from "@/store/htmlclass.module.js";

//components
import listAthlete from "./listAthlete"
import listOfficial from "./listOfficial"
import DialogSearch from "./DialogSearch"
import DialogRegister from "./DialogRegister"

//services
import payrollService from "@/core/services/payroll.service"

export default {
    name: 'payroll',
    components: {
        listAthlete,
        listOfficial,
        DialogSearch,
        DialogRegister
    },
    data: () => ({
        activeItem: 'tab1',
        open_dialog_search: false,
        dialogTitle: "deportista",
        open_dialog_register: false,
        payroll: {},
        payrollList: [],
        record_type: 'DE'
    }),
    computed: {
        ...mapGetters(['oficialType'])
    },
    methods: {
        isActive(menuItem) {
            return this.activeItem === menuItem
        },
        setActive(menuItem) {
            console.log(menuItem)
            if(menuItem == 'tab1')
                this.record_type = 'DE'
            else {
                if(this.oficialType.length > 0){
                    this.record_type = this.oficialType[0].id;
                }
            }

            this.activeItem = menuItem
            this.loadPayroll()
        },
        resDialogSearch(data) {
            this.payroll = {}
            if (data) {
                this.open_dialog_search = data.existe
                this.open_dialog_register = !data.existe
                this.payroll = data
            }
        },
        onAddEdditDialog(data) {
            this.payroll = {}
            if (data) {
                this.open_dialog_search = false
                this.open_dialog_register = true
                this.payroll = data
            }
        },
        async loadPayroll(){
            this.$store.dispatch(ADD_BODY_CLASSNAME, "page-loading");
            await payrollService.getData({record_type: this.record_type}).then( (res) => {
                this.payrollList = res.data
                //console.log(res.data);
            }).catch( (error) => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
                code.Manager(error.response)
            }).finally( () => {
                this.$store.dispatch(REMOVE_BODY_CLASSNAME, "page-loading")
            })
        },
        openDialogSearch() {
            if(this.record_type !='')
                this.open_dialog_search = true
            else
                this.$message.error({ showClose: true, message: 'Falta seleccionar el tipo de oficial'})
        }
        
    },
    mounted() {
        this.loadPayroll()
    }

};
</script>
